import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  CreateStaffRequest,
  Staff,
  StaffSearchRequest,
  StaffSearchResponse,
  UpdateStaffRequest,
} from "./@types";

export const staffApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllStaff: builder.mutation<
      ApiSuccessResponse<StaffSearchResponse>,
      StaffSearchRequest
    >({
      query: (requestBody) => ({
        url: "/v1/staff/staff/search",
        method: "POST",
        body: requestBody,
      }),
    }),
    createStaff: builder.mutation<ApiSuccessResponse<any>, CreateStaffRequest>({
      query: (staffData) => ({
        url: "/v1/staff",
        method: "POST",
        body: { ...staffData },
      }),
    }),
    updateStaff: builder.mutation<ApiSuccessResponse<any>, UpdateStaffRequest>({
      query: (staffData) => ({
        url: `/v1/staff/staff/${staffData.id}`,
        method: "PUT",
        body: { ...staffData },
      }),
    }),
    getStaffById: builder.query<ApiSuccessResponse<Staff>, string>({
      query: (id) => ({
        url: `/v1/staff/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllStaffMutation,
  useCreateStaffMutation,
  useUpdateStaffMutation,
  useGetStaffByIdQuery,
} = staffApiSlice;
